import {ACTION_TYPES, Actions, InitialState} from './types';

const initialState: InitialState = {
    attestations: {},
    statistic: [],
};

const attestationStore = (state = initialState, {type, payload}: Actions) => {
    switch(type) {
        case ACTION_TYPES.GET_ATTESTATIONS_SUCCESS:
            return {
                ...state,
                //@ts-expect-error
                attestations: payload.reduce((acc, current) => {
                    acc[current.id] = current
                    return acc;
                }, {}),
            }

        case ACTION_TYPES.GET_ATTESTATION_SUBMISSION_SUCCESS:
            const attestations = {...state.attestations};
            const targetAttestation = {...(attestations[payload.attestationId] || {})};
            targetAttestation.lastSubmission = payload.lastSubmission;
            return {
                ...state,
                attestations: {
                    ...attestations,
                    [payload.attestationId]: targetAttestation,
                }
            }
        case ACTION_TYPES.GET_ATTESTATION_STATISTIC_SUCESS:
            return {
                ...state,
                statistic: payload,
            }
        default:
            return state;
    }
};

export default attestationStore;